module.exports = __webpack_public_path__ + "static/EchoKnight-604ace7d8c65c3ab4969d1dd1ae96fc4.webp";